import { ChevronRight, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { Button } from '@/components/ui/CustomButton';
import type { Company } from '@/types/company';
import styles from './SelectCompanyPage.module.css';
import { companyDisplayName } from '@gokrew/ui/utility/companyDisplayName';

interface SelectCompanyPageProps {
  companies: Company[];
  onSelectCompany: (company: Company) => void;
  onNewCompany: () => void;
}

export function SelectCompanyPage({
  companies,
  onSelectCompany,
  onNewCompany,
}: SelectCompanyPageProps) {
  const { t } = useTranslation(TranslationNS.Auth);
  const hasCompanies = companies.length > 0;

  return (
    <div>
      <h2 className={styles.heading}>
        {hasCompanies ? t('signup_v2.select_company.heading_existing') : t('signup_v2.select_company.heading_new')}
      </h2>
      <p className={styles.subtext}>
        {hasCompanies
          ? t('signup_v2.select_company.subtext_existing')
          : t('signup_v2.select_company.subtext_new')}
      </p>

      {hasCompanies && (
        <div>
          <p className={styles.sectionLabel}>{t('signup_v2.select_company.section_label')}</p>
          <div className={styles.companyList}>
            {companies.map((company) => (
              <button
                key={company.id}
                type="button"
                onClick={() => onSelectCompany(company)}
                className={styles.companyCard}
              >
                <div className={styles.companyAvatar}>
                  {company.logo ? (
                    <img
                      src={company.logo}
                      alt={companyDisplayName(company)}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className={styles.companyAvatarText}>
                      {companyDisplayName(company).slice(0, 2).toUpperCase()}
                    </span>
                  )}
                </div>
                <div className={styles.companyInfo}>
                  <p className={styles.companyName}>
                    {companyDisplayName(company)}
                  </p>
                  <p className={styles.companyRole}>{t('signup_v2.select_company.role_admin')}</p>
                </div>
                <ChevronRight size={16} className={styles.chevron} />
              </button>
            ))}
          </div>

          <div className={styles.divider}>
            <span className={styles.dividerText}>or</span>
          </div>
        </div>
      )}

      <Button
        variant="outline"
        className={styles.newCompanyBtn}
        IconPrefix={Plus}
        onClick={onNewCompany}
      >
        {t('signup_v2.select_company.new_company_btn')}
      </Button>
    </div>
  );
}
